import { Box, Button, Card, Grid, Group, Text, TextInput, Title } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import useFetch from '../../helpers/useFetch';

const NewPagePage = () => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const location = useLocation();
  const navigate = useNavigate();
  const [name, setName] = useState('New page');
  const [userError, setUserError] = useState();

  const submitForm = (e) => {
    e.preventDefault();
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`, {
      method: 'POST',
      body: JSON.stringify({ name }),
    })
      .then(({ page }) => {
        const { type } = queryString.parse(location.search);
        navigate(location.pathname.replace('/pages/new', `/pages?type=${type}&page=${page.id}`));
      })
      .catch(setUserError);
  };

  return (
    <>
      <Grid pt="60">
        <Grid.Col span={3}></Grid.Col>
        <Grid.Col span={6}>
          <Card withBorder>
            <Title order={2} ta="center" mb="lg">New Page</Title>
            <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
              <Grid>
                <Grid.Col span={4}>
                  <Text fw={500}>Page Name</Text>
                </Grid.Col>
                <Grid.Col span={8}>
                  <TextInput
                    name="name"
                    type="text"
                    placeholder="Home Page"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid.Col>
              </Grid>
              <Group justify="flex-end" gap="xs" py="md">
                <Button variant="default" type="button" onClick={() => navigate(-1)}>
                  {' '}
                  Cancel
                </Button>
                <Button disabled={!name} type="submit">
                  <IconDeviceFloppy size={14} /> Save
                </Button>
              </Group>
            </Box>
            {userError && (
              <div style={{ textAlign: 'right' }}>
                <ErrorMessage message={userError.message} />
              </div>
            )}
          </Card>
        </Grid.Col>
        <Grid.Col span={3}></Grid.Col>
      </Grid>
    </>
  );
};

export default NewPagePage;
